import _ from 'lodash';
import React from 'react';
import countries from 'i18n-iso-countries';
import ResponsiveSelect from './ResponsiveSelect';

const devices = [
  { label: 'Custom resolution', value: 'custom', resolution: null },

  { label: 'iPhone X (1125 x 2436)', value: 'iphone-x', resolution: { width: 1125, height: 2436 } },
  { label: 'iPhone 6+, 7+, 8+ (1080 x 1920)', value: 'iphone-8p', resolution: { width: 1080, height: 1920 } },
  { label: 'iPhone 6, 7, 8 (750 x 1334)', value: 'iphone-8', resolution: { width: 750, height: 1334 } },
  { label: 'iPhone SE, 5 (640 x 1136)', value: 'iphone-se', resolution: { width: 640, height: 1136 } },

  { label: 'Google Pixel 2 XL(1440 x 2880)', value: 'pixel-2xl', resolution: { width: 1440, height: 2880 } },
  { label: 'HTC U Ultra (1440 x 2560)', value: 'htc-u-ultra', resolution: { width: 1440, height: 2560 } },
  { label: 'Huawei P10 (1080 x 1920)', value: 'huawei-p10', resolution: { width: 1080, height: 1920 } },
  { label: 'LG G6 (1440 x 2880)', value: 'lg-g6', resolution: { width: 1440, height: 2880 } },
  { label: 'OnePlus 5 (1080 x 1920)', value: 'oneplus-5', resolution: { width: 1080, height: 1920 } },
  { label: 'Samsung Galaxy S8, S8+, S9, S9+ (1440 x 2960)', value: 'samsung-galaxy-s9', resolution: { width: 1440, height: 2960 } },
  { label: 'Xiaomi Mi 6 (1080 x 1920)', value: 'xiaomi-mi-6', resolution: { width: 1080, height: 1920 } },
];

const selectFilterFunc = (input, option) =>
  _.startsWith(option.props.label.toLowerCase(), input.toLowerCase());

const DeviceSelect = React.createClass({
  render() {
    return (
      <ResponsiveSelect
        {...this.props}
        size="large"
        className="DeviceSelect"
        showSearch
        placeholder="Enter a device name"
        optionFilterProp="children"
        onChange={this._onChange}
        options={_.map(devices, (item) => ({
          key: item.label,
          value: item.value,
          label: item.label,
          resolution: item.resolution,
        }))}
      />
    );
  },

  _onChange(val) {
    const device = _.find(devices, d => d.value === val);
    this.props.onChange(device);
  }
});

export const allDevices = devices;
export default DeviceSelect;


// WEBPACK FOOTER //
// ./src/components/DeviceSelect.js